import { View, Badge } from "@/components/ui";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import React from "react";
import { Typography } from "../typography";

const accountInfoCardVariants = cva("flex justify-between p-4", {
  variants: {
    direction: {
      col: "flex-col",
      row: "flex-row",
    },
  },
  defaultVariants: {
    direction: "row",
  },
});

type AccountInfoCardVariantProps = VariantProps<typeof accountInfoCardVariants>;

interface AccountInfoCardProps extends AccountInfoCardVariantProps {
  primary: boolean;
  header: string;
  bodyText: string | number;
  subBodyText: string;
  actions?: React.ReactNode;
  colBodyText?: boolean;
}

export function AccountInfoCard({
  header,
  primary,
  bodyText,
  subBodyText,
  actions,
  direction,
  colBodyText,
}: AccountInfoCardProps) {
  const hasSubBodyText = subBodyText.trim().length > 0;

  return (
    <Card>
      <CardContent className={accountInfoCardVariants({ direction })}>
        <View className="flex flex-col gap-2 p-0">
          <View className="flex max-w-[160px] flex-row items-center gap-2 md:max-w-full">
            <Typography variant="body-md" numberOfLines={1}>
              {header}
            </Typography>
            {primary && <Badge variant="primary">Default</Badge>}
          </View>
          <View
            className={cn(
              "flex max-w-[200px] gap-2 text-wrap",
              colBodyText ? "flex-col" : "flex-row",
            )}
          >
            <Typography variant="body-sm" color="muted-foreground">
              {bodyText}
            </Typography>

            {hasSubBodyText && (
              <Typography
                color="muted-foreground"
                variant="body-sm"
                numberOfLines={1}
              >
                {subBodyText}
              </Typography>
            )}
          </View>
        </View>

        <View className="flex w-full max-w-[126px] flex-row gap-2 py-2">
          {actions}
        </View>
      </CardContent>
    </Card>
  );
}
